<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal")
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('attach_members') }}

        v-card-text.pa-0
          v-container.white.pa-4(style="max-width:600px")
            v-text-field(v-model="searchText" :placeholder="$t('search_member')" hide-details dense outlined height="40" background-color="basic200")
              template(v-slot:append)
                eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
          
          v-container.px-1(style="max-width:600px")
            v-layout.my-6(v-if="isFetching")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .contain-layout(v-else)
              v-layout.my-6(v-if="members.length == 0")
                v-row.fill-height.ma-0(align='center' justify='center')
                  div.mx-auto
                    v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                    p.caption {{ $t('members_not_found') }}
              div(v-else)
                template(v-for="(member, index) in members")
                  v-card(flat @click="clickMember(member, index)")
                    v-row.px-4(no-gutters align="center")
                      v-col.shrink
                        intel-avatar.mr-3(:code="member.user.avatar_code" :id="member.user.id" size=48)
                      v-col.py-2.px-2
                        div.s1.basic800--text.mb-1 {{ member.user.first_name + ' ' + member.user.last_name }}
                        div.p2.primary500--text {{ $t('lead') }}: {{ member.total_leads }}
                        div.p2.primary500--text(v-if="authMember.role === 'Admin' || authMember.id == member.id") Sales: {{ member.total_sales | displayPrice }}
                      v-col.py-2.shrink
                        y-checkbox.ma-0.pa-0(v-model="member.selected" readonly)
                  v-divider.basic300
                
              div.ma-4
                y-pagination(v-model="page" :pageSize="fetchCount" :count="count")

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32  @click="clickDone" :loading="isLoading" dark)
            .button-AA-small.basic100--text {{ $t('done') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import IntelAvatar from '@/components/IntelAvatar.vue'

export default {
  name: 'AttachMembers',
  props: ['open', 'initialMembers'],
  components: { IntelAvatar },
  data: () => ({
    isFetching: false,
    fetchCount: 20,
    page: 1,
    // totalPage: 1,
    count: 0,
    members: [],
    selectedMembers: [],
    searchText: '',
    searchCountDown: null,
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    authMember () {
      return this.$store.state.user.member
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page (val) {
      if (!this.isFetching) {
        this.fetchMembers(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  mounted () {
    this.selectedMembers = [...this.initialMembers]
    this.fetchMembers(1)
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickMember (member, index) {
      this.members[index].selected = !this.members[index].selected
      this.updateMember(this.members[index])
    },
    updateMember (member) {
      if (member.selected) {
        this.addMember(member)
      } else {
        this.removeMember(member)
      }
    },
    addMember (member) {
      this.selectedMembers.push(member)
    },
    removeMember (member) {
      this.selectedMembers = this.selectedMembers.filter((x) => x.id !== member.id)
    },
    getSelected (member) {
      let selmember = this.selectedMembers.filter(f => f.id === member.id)
      if (selmember.length > 0) {
        return true
      }
      return false
    },
    fetchMembers(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let fetchUrl = `/members/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id&exclude_roles=5`
      if (this.searchText) {
        fetchUrl += `&search=${this.searchText}`
      }
      this.$axios.get(fetchUrl)
      .then((response) => {
        this.isFetching = false
        this.members = response.data.results.map(m => { return { ...m, selected: this.getSelected(m) } })
        this.count = response.data.count
      })
      .catch(() => {})
    },
    searchItem () {
      let searchUrl = `/members/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id&exclude_roles=5`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.members = response.data.results.map(m => { return { ...m, selected: this.getSelected(m) } })
          this.count = response.data.count
        })
        .catch(() => {})
    },
    clickDone () {
      this.showModal = false
      this.$emit('update:initialMembers', this.selectedMembers)
    }
  }
}
</script>

<style scoped>
.member-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; 
  overflow: hidden;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>
